/* eslint-disable @typescript-eslint/no-explicit-any */
import { IPaymentVo } from "../checkout.interface";

function getFormatPaymentList(paymentList: any[]=[]) {
  console.log("Jing-----paymentList: ", paymentList);
  
  const list: IPaymentVo[] = paymentList.map((payment: any) => {
    const rememberInfos = payment.rememberInfos ? JSON.parse(payment.rememberInfos) : {};
    return {
      // selected: payment.checked === 1,
      selected: payment.selected || payment.checked === 1,
      iconUrl: payment.logoUrl || payment.iconUrl,
      payToolId: String(payment.payMethod) || String(payment.payToolId),
      payMethod: Number(payment.payMethod) || Number(payment.payToolId),
      payToolName: payment.desc || payment.payToolName,
      payEnum: payment.payEnum,
      integrationType: payment.integrationType,
      enabled: payment.enabled,
      tips: payment.tips ? JSON.parse(payment.tips) : [],
      prompt: payment.prompt ? JSON.parse(payment.prompt) : null,
      supportBrands: payment.supportBrands ? JSON.parse(payment.supportBrands) : [],
      unselectTips: payment.unselectTips ? JSON.parse(payment.unselectTips) : [],
      paymentAccountList: rememberInfos.accountList || [],
      isOpenFastPay: payment.rememberInfos ? true : false,
      rememberInfo: {
        addNewAccountTitle: rememberInfos.addNewAccountTitle || "",
        rememberAccountTips: rememberInfos.rememberAccountTips || "",
        rememberCheckboxTitle: rememberInfos.rememberCheckboxTitle || "",
        useNewAccount: rememberInfos.useNewAccount || false,
        rememberCheckbox: rememberInfos.rememberCheckbox || false,
      },
      initConfig: payment.initConfig ? JSON.parse(payment.initConfig) : {},
    };
  });

  // if (list.filter((item) => item.selected).length === 0) {
  //   list[0].selected = true;
  // }
  return list;
}

export { getFormatPaymentList };
